// @flow
import React, {Component, Fragment} from 'react';
import Button from 'antd/lib/button';
import {Link} from '@reach/router';
import {connect} from 'react-redux';
import styled from 'styled-components';

import type {AttachedEquipment, ListState, UserAccess} from '../../../lib/types';
import Filter, {type AttachedEquipmentFilterParams} from './Filter';
import type {AppState} from '../../../ducks/redux';
import {Table} from './../../../components/ui';
import {Section} from './../../../components/layout';
import Header from '../../../components/layout/Header';
import {Panel} from '../../../components/layout';
import NavigationTabs from '../components/NavigationTabs';
import {withUserAccess} from './../../withUserAccess';
import {accessTypeEnum} from '../../../lib/enum';
import {attachedEquipmentApi, type FetchListParams} from './../../../lib/api';
import {getListInitialState, navigate, setQueryParams} from '../../../lib/helpers';
import qs from 'query-string';

const StyledPanel = styled(Panel)`
  padding-bottom: 0;
  padding-top: 0;
`;
const PanelTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const canAddAttachedEquipmentAccess = [
  accessTypeEnum.admin,
  accessTypeEnum.handlingEquipment,
];

type Props = {
  location: Location & { state: { page: number } },
  userAccess: UserAccess[],
  employeeBranchOrgUnitId: number
};

type State = ListState<AttachedEquipment> & {
  filter: AttachedEquipmentFilterParams
};

/** Вывод списка навесного оборудования */
class List extends Component<Props, State> {
  static defaultProps = {
    location: {},
  };
  state = {
    ...getListInitialState(),
    filter: {},
  };
  columns = [
    {title: '№', dataIndex: 'id', sorter: true, width: 25},
    {title: 'Мнемокод', dataIndex: 'code', sorter: true},
    {title: 'Наименование', dataIndex: 'name', sorter: true},
    {
      title: 'Марка',
      dataIndex: 'brandName',
      sorter: true,
      sorterKey: 'brand.name',
    },
    {
      title: 'Характеристики',
      dataIndex: 'specifications',
      width: 350,
      breakByWidth: true,
    },
  ];
  getDefaultFilter = () => {
    const canViewAll = this.props.userAccess.some(access =>
      [accessTypeEnum.viewingAllEquipments].includes(access),
    );
    const defaultFilter = canViewAll
      ? {}
      : ({
        orgUnitId: this.props.employeeBranchOrgUnitId,
        nodeFilterType: 'branchAndChildren',
      }: AttachedEquipmentFilterParams);
    return defaultFilter;
  };
  componentDidMount() {
    const {page, ...filter} = qs.parse(window.location.search);
    this.setState({filter: filter || this.getDefaultFilter()}, () => this.fetchAttachedEquipments(page || 1));
  }
  fetchAttachedEquipments = async (
    page: number = 1,
    params: FetchListParams<AttachedEquipmentFilterParams> = {},
  ) => {
    const {filter} = this.state;
    this.setState({loading: true});
    const {
      data,
      totalCount,
    } = await attachedEquipmentApi.fetchAttachedEquipments({
      ...filter,
      page,
      ...params,
      // $FlowFixMe flow говорит, что идет перекрытие параметра where
      ...this.getDefaultFilter(), // фильтр по оргюнитам в зависимости от клэймов
    });
    setQueryParams({page});
    this.setState({loading: false, data, totalCount, page});
  };
  handleRowClick = (id: number) => navigate(`/equipment/attached/${id}`);

  cleanFilter = () =>
    this.setState({filter: {}}, this.fetchAttachedEquipments);

  applyFilter = (filter: AttachedEquipmentFilterParams) =>
    this.setState({filter}, this.fetchAttachedEquipments);

  render() {
    const {location, userAccess} = this.props;
    const {data, totalCount, page, pageSize, loading, filter} = this.state;

    const canAdd = userAccess.some(access =>
      canAddAttachedEquipmentAccess.includes(access),
    );
    return (
      <Fragment>
        <Header
          left={(
            <PanelTitle>
              <h1>Навесное и дополнительное оборудование</h1>
            </PanelTitle>
          )}
          right={canAdd && (
            <Link to="/equipment/attached/new">
              <Button data-cy="addAttached" type="primary">
                Создать
              </Button>
            </Link>
          )}
        />
        <StyledPanel>
          <NavigationTabs defaultTab="attached" />
        </StyledPanel>
        <Section>
          <Filter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter}
          />
          <Table
            onRow={record => ({
              onClick: () => this.handleRowClick(record.id),
            })}
            loading={loading}
            data={data.map(tire => ({
              ...tire,
              key: tire.id,
            }))}
            fetch={this.fetchAttachedEquipments}
            columns={this.columns}
            pagination={{
              page,
              pageSize,
              totalCount,
              location,
            }}
          />
        </Section>
      </Fragment>
    );
  }
}

export default connect((state: AppState) => ({
  employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId,
}))(withUserAccess(List));
